<template>
    <div class="">
        <navbar :transparent="isTransparent" activeTo="Services"></navbar>
        <div class="example-problem-group">
            <div class="max_width" style="width: 90%;">
                <div style="text-align: left;font-size: 24px;" @click="goBack">
                    <Icon type="chevron-left"></Icon>
                </div>
                <div class="Product-search">
                    <input class="Product-search-input" v-model="searchWord" @keyup.enter="searchFaq" :placeholder="$t('enter_keyword')">
                    <img class="Product-search-icon" src="../../assets/search_icon.png" width="24" @click="searchFaq">
                </div>
            </div>
            <div class="example-problem"  v-if="null_problem_list_show">
                <div class="example-problem-main">
                    <h2 style="margin-top: 10%;font-size: 30px;">{{$t('contact_us')}}</h2>
                    <p style="margin: 30px 0;">{{$t('faq_service')}}</p>
                    <div class="contact_way pcShow" v-for="(item,index) in contace_list" :key="index">
                        <div class="contact_item1">
                            <img :src="item.img" width="40">
                        </div>
                        <div class="contact_item2">
                            <p>{{item.contact_tile}}:</p>
                        </div>
                        <div style="clear: both"></div>
                        <div class="contact_item3">
                            <p>{{item.contact_phone}}</p>
                        </div>
                    </div>
                    <div class="contact_way mobileShow" v-for="(item,index) in contace_list" :key="index">
                        <div class="contact_item1">
                            <img :src="item.img" width="40">
                        </div>
                        <div class="contact_item2">
                            <p>{{item.contact_tile}}:</p>
                            <p>{{item.contact_phone}}</p>
                        </div>
                        <div style="clear: both"></div>
                    </div>
                </div>
            </div>
            <div class="example-problem" v-for='(item,index,key) in problem_list' :key="index"  v-else>
                <div class="example-problem-main">
                    <h2>{{item.title}}</h2>
                    <p v-html="item.content"></p>
                    <router-link :to="{name:'problemContent',params:{id:item.id}}" class="remain">
                        {{$t('Services_mainpage_remain_to_be_solved')}}
                        <Icon type="chevron-right"></Icon>
                    </router-link>
                </div>
            </div>

            <div class="pages" style="margin: 10px;padding-left:4%;">
                <page :total="total" :length="limit" @on-change="refreshData"></page>
            </div>
        </div>
    </div>

</template>

<script>
    import Signature from '../../lib/Signature'
    import page from '../Common/Page.vue'
    import navbar from '../Common/Navbar.vue'

    export default {
        name: 'ProblemList',
        data () {
            return {
                problem_list: [],
                problem_type: null,
                searchWord:'',
                isTransparent:false,
                limit: 4,
                null_problem_list_show:false,
                page: 1,
                total: 0,
                contace_list: [
                    {
                        img:require('../../assets/wechat.png'),
                        contact_tile:this.$t('contact_way2'),
                        contact_phone:'IFREEGROUP'
                    },
                    {
                        img:require('../../assets/004-whatsapp.png'),
                        contact_tile:'WhatsApp在线客服ID',
                        contact_phone:'+4474 5204 6699'
                    },
                    {
                        img:require('../../assets/icon50_call.png'),
                        contact_tile:'网页客服地址',
                        contact_phone:'www.ifree.ly/support'
                    }
                ]
            }
        },
        props: {
            services: Array
        },
        components: {
            page,navbar
        },
        watch: {
            '$route': function (to, from) {
                this.fetchData(this.page, this.limit)
            }
        },
        created () {
            this.fetchData(this.page, this.limit)
            this.searchWord = this.$route.query.keywords
        },
        methods: {
            goBack () {
                this.$router.go(-1)
            },
            refreshData (page) {
                this.fetchData(page, this.limit)
            },
            fetchData (page, limit) {
                this.problem_type = this.$route.params.type || null
                const module = 'index.php/faq/list'
                let data = {}
                data.user_id = this.Local.getUserId()
                data.lang = this.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                if (this.problem_type !== null) {
                    data.problem_type = this.problem_type
                }
                data.keywords = this.$route.query.keywords || ''
                data.category_id = this.$route.query.category_id
                data.id = this.$route.query.id
                data.limit = limit
                data.page = page
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        console.log(response.data)
                        this.problem_list = response.data.data.problem_list
                        this.null_problem_list = response.data.data.problem_list.length
                        this.total = response.data.data.total
                        if(this.null_problem_list == 0) {
                            this.null_problem_list_show = true
                        }else{
                            this.null_problem_list_show = false
                        }
                    }.bind(this))
            },
            searchFaq () {
                this.$router.push({
                    name: 'problemSearch',
                    query: {keywords: this.searchWord}
                })
            }
        }
    }
</script>

<style>
    .example-problem-group{
        padding: 80px 0;
    }
    .example-problem {
        width: 90%;
        margin: 0 auto;
        border-bottom: 2px solid #D3DCE6;
        text-align: left;
        max-width: 1240px;
    }

    .Product-search {
        width: 40%;
        min-width: 300px;
        padding: 30px 0 20px 0;
    }

    .Product-search-input {
        width: 90%;
        border: 1px solid #5E6D82;
        background: white;
        font-size: 16px;
        position: relative;
        padding: 15px 5px 15px 5px;
        max-width: 500px;
        border-radius: 4px;
    }

    .Product-search-icon {
        position: absolute;
        margin: 15px 0 0 -40px;
    }

    .example-problem-main {
        width: 95%;
        margin: 20px auto;
    }

    .remain {
        font-size: 16px;
        color: #0084FF;
        position: relative;
    }

    .remain-icon {
        position: absolute;
        right: -16px;
        top: -1px;
    }

    .example-problem-main h2 {
        font-size: 24px;
        font-weight: 500;
    }

    .example-problem-main p {
        font-size: 16px;
        color: #5E6D82;
        margin: 10px 0 5px 0;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .contact_way{
        max-width: 550px;
        display: flex;
        margin: 20px 0;
    }
    .contact_way .contact_item1{
        width: 12%;
    }
    .contact_way .contact_item2{
        width: 35%;
    }
    .contact_way .contact_item3{
        width: 50%;
    }
    .mobileShow{
        display: none !important;
    }
    @media (max-width:414px) {
        .mobileShow{
            display: block !important;
        }
        .pcShow{
            display: none !important;
        }
        .contact_way{
            max-width: 550px;
            display: block;
            margin: 20px 0;
        }
        .contact_way .contact_item1{
            width: 20%;
            float: left;
        }
        .contact_way .contact_item2{
            width: 80%;
            float: left;
        }
        .contact_way .contact_item3{
            width: 50%;
        }
    }
</style>



// WEBPACK FOOTER //
// ProblemSearch.vue?fb5d1138